import { $$, REDUCED } from '../lib/dom.js';

export function initTilt() {
  if (REDUCED) return;
  $$('.player').forEach(card => {
    if (card.dataset.tiltBound) return;
    card.dataset.tiltBound = '1';
    let raf = 0, tx = 0, ty = 0, ctx = 0, cty = 0;

    function reset() {
      cancelAnimationFrame(raf);
      raf = 0;
      card.style.transition = 'transform 500ms cubic-bezier(.2,.7,.2,1)';
      card.style.transform = '';
      card.style.setProperty('--mx', '50%');
      card.style.setProperty('--my', '30%');
    }

    function onMove(e) {
      const r = card.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width;
      const py = (e.clientY - r.top) / r.height;
      tx = (py - 0.5) * -8;
      ty = (px - 0.5) * 10;
      card.style.setProperty('--mx', (px * 100) + '%');
      card.style.setProperty('--my', (py * 100) + '%');
      if (!raf) {
        card.style.transition = '';
        const tick = () => {
          ctx += (tx - ctx) * 0.18;
          cty += (ty - cty) * 0.18;
          card.style.transform =
            `perspective(1200px) rotateX(${ctx.toFixed(2)}deg) rotateY(${cty.toFixed(2)}deg) translateZ(0)`;
          if (Math.abs(tx - ctx) > 0.05 || Math.abs(ty - cty) > 0.05) {
            raf = requestAnimationFrame(tick);
          } else {
            raf = 0;
          }
        };
        raf = requestAnimationFrame(tick);
      }
    }

    card.addEventListener('pointermove', onMove);
    card.addEventListener('pointerleave', reset);
  });
}
